export const lifeEvent = {
    region: '',
    language: '',
    type: '',
    get schema() {
        return {
            title: 'Life Event',
            type: 'array',
            items: {
                type: 'object',
                title: 'Entry',
                properties: {
                    title: {
                        title: 'Title',
                        type: 'string',
                    },
                    description: {
                        title: 'Description',
                        type: 'string',
                        format: 'textarea',
                    },
                    takeAction: {
                        title: 'Take Action',
                        type: 'array',
                        items: {
                            type: 'object',
                            title: 'Take Action Entry',
                            properties: {
                                text: {
                                    title: 'Text',
                                    type: 'string',
                                },
                                link: {
                                    title: 'Link',
                                    type: 'string',
                                },
                                linkType: {
                                    title: 'Link Type',
                                    type: 'string',
                                },
                                items: {
                                    type: 'array',
                                    title: 'Items',
                                    items: {
                                        type: 'object',
                                        title: 'Items Entry',
                                        properties: {
                                            text: {
                                                title: 'Text',
                                                type: 'string',
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                    learnMore: {
                        title: 'Learn More',
                        type: 'array',
                        items: {
                            type: 'object',
                            title: 'Learn More Entry',
                            properties: {
                                text: {
                                    title: 'Title',
                                    type: 'string',
                                },
                                link: {
                                    title: 'Link',
                                    type: 'string',
                                },
                                linkType: {
                                    title: 'Link Type',
                                    type: 'string',
                                },
                                items: {
                                    type: 'array',
                                    title: 'Items',
                                    items: {
                                        type: 'object',
                                        title: 'Items Entry',
                                        properties: {
                                            text: {
                                                title: 'Text',
                                                type: 'string',
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                    benefitTag: {
                        title: 'Benefit Tag',
                        type: 'array',
                        items: {
                            title: 'Tag',
                            type: 'string',
                        },
                    },
                },
            },
        };
    },
};
//# sourceMappingURL=lifeEventJsonEditorConfig.js.map